<div class="deposit-limit-actions">
	<button
		mat-flat-button
		test-id="deposit-limit-edit-cancel"
		[attr.test-id]="limitKey + '-cancel'"
		class="deposit-limit-actions-cancel"
		(click)="cancel.emit()"
	>
		{{ "general.cancel" | translate }}
	</button>
	<button
		class="obg-m-multi-deposit-limit-submit deposit-limit-actions-submit"
		[attr.test-id]="limitKey + '-submit'"
		mat-flat-button
		color="accent"
		[disabled]="invalid || setDepositLoading"
		(click)="formSubmit.emit()"
	>
		<mat-spinner *ngIf="setDepositLoading; else showContent" diameter="20"></mat-spinner>
		<ng-template #showContent
			>{{
				(redirectToDeposit
					? "multi-deposit-limit.set-limit-and-deposit"
					: sessionLimitsUnset
						? "general.continue"
						: "multi-deposit-limit.set-limit"
				) | translate
			}}
		</ng-template>
	</button>
</div>
